var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[_c('header',[_c('h1',{staticClass:"title"},[_vm._v("\n      "+_vm._s(_vm.$dt(_vm.title))+"\n    ")])]),_c('main',[_vm._l((_vm.blocks),function(block,i){return [(block.type == 'text')?_c('NewsletterTextBlock',{key:i,attrs:{"data":block}}):_vm._e()]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }